declare const __SEEQLITE_BUILD_ID__: string;

export const BUILD_ID = __SEEQLITE_BUILD_ID__;
